<form (ngSubmit)="onSuccessAdd()" [formGroup]="form">
    <div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title translate>add_usine</h2>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content>
        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl(filed.name_usine)"
                        [label]="'Nom de l\'usine'"
                ></app-text-field>
            </div>
            <div fxFlex.gt-sm="25" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl(filed.tel_num)"

                        [label]="'tel_fixe'"
                        [numberphone]="true"
                ></app-text-field>
            </div>

            <div fxFlex.gt-sm="25" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl(filed.fax)"
                        [label]="'fax'"
                        [numberphone]="true"
                ></app-text-field>
            </div>

        </div>
        <div class="pc" fxLayout="row wrap">
            <app-select-codepostal
                #sele
                (gouvernoratadd)="get($event)"
                [controladrese]="getFormControl(filed.address1)"
                [controlcode]="getFormControl(filed.codepostale)"
                [delegation]="sele?.selectDelegationComponent?.mat?.value"
                [etrangere]="getFormControl(filed.etrangere)"
                [gouvernorat]="sele?.selectGouvernoratComponent?.matselcet?.value"
                [ville]="sele?.selectVilleBygouvandDelComponent?.matselect?.value"
                [withchecketrangere]="true"
            ></app-select-codepostal>
        </div>
        <div class="pc" fxLayout="row wrap">
            <app-text-field [control]="getFormControl(filed.adreese2)" [label]="'adress2'"
                            fxFlex.gt-sm="100"
                            fxFlex.lt-md="100"
            ></app-text-field>

        </div>

    </div>
    <div class="pc" fxLayoutAlign="end end" mat-dialog-actions>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <button color="primary" mat-raised-button type="submit">
                {{ "submit" | translate }}
            </button>
        </div>
    </div>
</form>
